import Cookies from 'universal-cookie';

const cookies = new Cookies();

const COOKIE_EXPIRY = new Date(Date.now() + 365 * 3 * 86400000);

export const getAuth = () => cookies.get('AUTH');

export const setAuth = (authObject) => {
  // Preserve storeToken if a child store is currently active — setAuth is called
  // on every page load and session update, which would otherwise wipe the token.
  const existing = getAuth();
  const toSave = existing?.storeToken
    ? { ...authObject, storeToken: existing.storeToken }
    : authObject;
  cookies.set('AUTH', JSON.stringify(toSave), {
    path: '/',
    expires: COOKIE_EXPIRY,
  });
  return toSave;
};

export const setStoreToken = (storeToken) => {
  const auth = getAuth() || {};
  if (storeToken) {
    auth.storeToken = storeToken;
  } else {
    delete auth.storeToken;
  }
  cookies.set('AUTH', JSON.stringify(auth), { path: '/', expires: COOKIE_EXPIRY });
};

export const removeAuth = () => {
  cookies.remove('AUTH', { path: '/' });
};
